import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useChutexAuth } from "../../context/ChutexAuthContext";
import { isAccountantOnly } from "../../lib/chutexAuth";

export default function ChutexProtectedRoute() {
  const { isAuthenticated, loading } = useChutexAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white text-zinc-500 text-sm">
        Vérification de la session…
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (isAccountantOnly() && !location.pathname.startsWith("/compta")) {
    return <Navigate to="/compta" replace />;
  }

  return <Outlet />;
}
